





















import Vue from "vue";
import { Component } from "vue-property-decorator";
import { TemplateTypes } from "@/data/enums/templates";

@Component({
  components: {
    "templates-provider": () =>
      import("@/components/app/global/templates/templatesProvider.vue"),
    "client-templates-templates-listing": () =>
      import("@/components/app/admin/clientTemplates/templatesListing.vue")
  }
})
export default class AdminClientTemplates extends Vue {
  // Computed
  public get templatesProviderProps() {
    return {
      handleLoading: false,
      templateType: TemplateTypes.CLIENT_TEMPLATE
    };
  }
}
